/**
 * The two entries of the Academy home (D-107): « Mon parcours » (the next lesson, or the level to
 * start with) and « Méthode et astuces » (always open). Shared by the TCF and the IELTS homes.
 */

import { Badge, buttonClass } from "@agencyos/ui-web";
import { Route } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { MethodEntry, useCoursePath } from "./CoursePage";
import { useMethod } from "./MethodPage";

export function CourseEntries({ exam, beginner = false }: { exam: string; beginner?: boolean }) {
  const { t } = useTranslation();
  const { path, locked } = useCoursePath(true, exam);
  const { method } = useMethod(exam);
  return (
    <section className="ac-course-entries" aria-label={t("academyCourse.home.label")}>
      <Link to="/academy/course" className="ac-card ac-method-entry ao-pressable">
        <span className="ac-pastille ac-tone--accent" aria-hidden="true">
          <Route size={18} />
        </span>
        <span className="ac-method-entry__text">
          <span className="ac-card-title">{t("academyCourse.home.course")}</span>
          <span className="ac-secondary">
            {beginner ? t("academyCourse.home.beginner") : locked ? t("academyCourse.home.locked") : t("academyCourse.home.courseText")}
          </span>
        </span>
        <span className="ac-method-entry__meta">
          {path && path.total > 0 && <span className="ac-caption ao-num">{t("academyCourse.home.progress", { done: path.completed, total: path.total })}</span>}
          {beginner && <Badge tone="success">{t("academyCourse.home.fromZero")}</Badge>}
          <span className={buttonClass("tinted", { size: "sm" })}>{t("academyCourse.home.open")}</span>
        </span>
      </Link>
      {method && method.open && <MethodEntry lessons={method.lessons} free={method.free} />}
    </section>
  );
}

/** « Méthode et astuces » alone (the IELTS home already shows the course). */
export function MethodHomeEntry({ exam }: { exam: string }) {
  const { method } = useMethod(exam);
  return method && method.open && method.lessons > 0 ? <MethodEntry lessons={method.lessons} free={method.free} /> : null;
}
